import { render, staticRenderFns } from "./POIOverview.vue?vue&type=template&id=06bfcf16&scoped=true&"
import script from "./POIOverview.vue?vue&type=script&lang=js&"
export * from "./POIOverview.vue?vue&type=script&lang=js&"
import style0 from "./POIOverview.vue?vue&type=style&index=0&id=06bfcf16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bfcf16",
  null
  
)

export default component.exports